/**
 * TileLoader — four tiles laid one after another, clockwise (logo colors,
 * flat). Used as Suspense fallback between portal pages.
 */
export function TileLoader({ size = 56, label, fill = false }: { size?: number; label?: string; fill?: boolean }) {
  return (
    <div className={`tile-loader-wrap${fill ? ' tile-loader-wrap--fill' : ''}`} role="status" aria-live="polite">
      <span className="tile-loader" style={{ width: size, height: size }} aria-hidden>
        <i />
        <i />
        <i />
        <i />
      </span>
      {label ? <span className="tile-loader-label">{label}</span> : <span className="sr-only">Loading</span>}
    </div>
  )
}

export default TileLoader
